import { ModelNv } from './modelNv';
import { ZarazeniPnv } from './zarazeniPnv';

export const menu = {
	name: 'CiselnikNoveVozy',
	list: [
		{ name: 'ModelNv', route: ModelNv.name },
		{ name: 'ZarazeniPnv', route: ZarazeniPnv.name },
	],
};
